export const PLANNING_DEFINITIONS_TAB_ID = "definitions";
